<template>
  <div
    class="menu__item-dropdown"
    :class="{[classActiveMenu]: showItem === item.name}"
  >
    <div
      class="menu__item-link"
      @click.prevent="toggleShowModal(item.name)"
    >
      <span v-if="showIcon" class="material-icons icon-image-preview">
         {{ item.icon }}
      </span>
      <div v-if="showText" class="menu__item-text">{{ item.label }}</div>
    </div>
    <MenuChild
      class="menu__child"
      v-if="showItem === item.name"
      :data="item.children"
    />
  </div>
</template>

<script>
const MenuChild = () => import('@components/Menu/MenuChild.vue')

export default {
  components: { MenuChild },
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    showText: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object
    },
    showItem: {
      type: String
    },
    classActiveMenu: {
      type: String
    }
  },
  methods: {
    toggleShowModal (name) {
      this.$emit('toggleShowModal', name)
    }
  }
}
</script>
